module.exports = __webpack_public_path__ + "static/media/icon-btn-close.58899ee6.svg";